
To add a fixed footer that appears on all routes (except where specified), you can modify your template to include the AppFooter component. Here's an updated version of your code:

Updated Template with Fixed Footer
vue
Copy code
<template>
  <v-app>
    <!-- Render Header for routes not in specialRoutes -->
    <Header v-if="!isSpecialRoute" />
    <AppHeader v-if="$route.name === 'homePage'" />

    <!-- Render SpecialHeader for specific routes -->
    <SpecialHeader v-if="isSpecialRoute" />

    <v-main>
      <transition name="slide-fade" mode="out-in">
        <router-view/>
      </transition>
    </v-main>

    <!-- Footer: Display for all routes except special ones -->
    <profilefooter v-if="$route.name === 'Profile'" />
    <AppFooter v-if="$route.name === 'homePage'" />
  </v-app>
</template>

<script>
import "./assets/style/fonts.css";
import "./assets/style/style.css";
import Header from "../src/components/HeaderPage.vue";
import AppHeader from "../src/components/AppHeader.vue";
import AppFooter from "../src/components/AppFooter.vue";
import profilefooter from "./components/profilefooter.vue";
import SpecialHeader from "./components/SpecialHeader.vue";
import axios from "axios";

export default {
  name: 'App',

  components: {
    Header,
    AppHeader,
    AppFooter,
    profilefooter,
    SpecialHeader,
  },

  data() {
    return {
      specialRoutes: ['login', 'signup', 'ForgotPassword', 'signupNew', 'subscription', 'waitingPage', 'Payment', 'Renew', 'Upgrade', 'paymentRenew', 'paymentUpgrade','paymentBulk','teamSubscription','termsandconditions', 'refundpolicy'],
    };
  },

  computed: {
    isSpecialRoute() {
      return this.specialRoutes.includes(this.$route.name);
    },
  },

  beforeMount() {
    this.userDetails();
  },

  methods: {
    userDetails() {
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit("appLoading", false);
            this.$store.commit("userData", response.data.data);
            this.$store.commit("fullData", response.data);
            this.$store.commit("userType", response.data.data.usertype);
            this.$store.commit("menu", response.data.menus);
          } else {
            this.$store.commit("appLoading", false);
          }
        })
        .catch((err) => {
          this.$store.commit("appLoading", false);
          console.log(err);
        });
    },
  },
};
</script>

<style>
  /* Slide animation */
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: transform 0.3s ease, opacity 0.1s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(50%);
    opacity: 0;
  }
  </style>
